import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-right: 1px solid #222222;
  margin-bottom: 40px;
  border-right: none;
  width: 100%;

  .logo {
    width: 160px;
  }

  @media (max-width: 768px) {
    align-self: center;
    align-items: start;
    flex-direction: column;
    gap: 32px;
    margin-right: 0;
    padding-right: 0;
  }
`;

export const Icons = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  list-style: none;
  gap: 32px;
`;
